module.exports = "/_next/static/media/onboard-4-extension.679c4888.mp4";